import React from 'react';
import styled from 'styled-components';
import {Button, Modal, Table} from 'antd';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import {useOutlet, getOutlet, getNewOutlet} from 'reconnect.js';
import * as AppActions from '../../AppActions';
import {ModalCustomStyle} from '../../AppContext/customStyledCss';

getNewOutlet('AdminSelectMoraleModal', null, {autoDelete: false});

export default function AdminSelectMoraleWidget(props) {
  const [selectedMorale, setSelectedMorale] = React.useState(null);
  const [fetching, setFetching] = React.useState(false);

  //rjsf write "readOnly", but props get "readonly".
  const readonly = props.readonly === true || props.readOnly === true;

  React.useEffect(() => {
    const fetchRecordById = async (id) => {
      setFetching(true);

      try {
        setSelectedMorale(
          await JStorage.fetchOneDocument('morale', {
            id,
          }),
        );
      } catch (err) {
        console.warn(err);
      }

      setFetching(false);
    };

    if (props.value) {
      fetchRecordById(props.value);
    }
  }, [props.value]);

  return (
    <Wrapper>
      <div>
        {fetching ? (
          '設定中...'
        ) : !props.value ? (
          '尚未設定'
        ) : !selectedMorale ? (
          props.value
        ) : (
          <Button
            type="link"
            title="點選開啟新分頁編輯"
            href={`/admin/morales/?action=detail&id=${selectedMorale.id}`}>
            {selectedMorale.case_number_prefix} {selectedMorale.case_number}
          </Button>
        )}
      </div>

      {!readonly && (
        <>
          <Button
            onClick={() => {
              props.onChange('');
              setSelectedMorale(null);
            }}
            style={{marginRight: 10}}>
            清除
          </Button>
          <Button
            type="primary"
            onClick={() =>
              getOutlet('AdminSelectMoraleModal').update({
                onChange: (record) => {
                  props.onChange(record.id);
                },
              })
            }>
            搜尋
          </Button>
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  border: 1px solid var(--adminBorderColor);
  border-radius: 4px;
  padding: 15px;

  & > div {
    margin-right: 15px;
    letter-space: 1.5;
  }
`;

const pageSize = 20;
const Columns = ({onChange, hideModal}) => [
  {
    title: '查詢結果',
    key: '#',
    render: (_, record) => {
      return (
        <div
          style={{cursor: 'pointer'}}
          onClick={() => {
            onChange(record);
            setTimeout(() => {
              hideModal();
            }, 500);
          }}>
          <div>
            {record.case_number_prefix}
            {record.case_number}
          </div>
        </div>
      );
    },
  },
];

export function AdminSelectMoraleModal(props) {
  const [data, setData] = useOutlet('AdminSelectMoraleModal');
  return (
    <Modal
      title={null}
      footer={null}
      bodyStyle={{padding: 0}}
      width={600}
      visible={!!data}
      onOk={() => {
        setData(null);
      }}
      onCancel={() => {
        setData(null);
      }}
      destroyOnClose={true}>
      {data && (
        <ModalContent
          data={{
            onChange: data.onChange,
            hideModal: () => setData(null),
          }}
        />
      )}
    </Modal>
  );
}

function ModalContent(props) {
  const {
    data: {onChange, hideModal},
  } = props;
  const [paging, setPaging] = React.useState({offset: 0, limit: pageSize});
  const [keyword, setKeyword] = React.useState('');
  const [fetchResp, setFetchResp] = React.useState(null);

  async function fetchData(_keyword, _paging) {
    AppActions.setLoading(true);
    try {
      const resp = await JStorage.fetchDocuments(
        'morale',
        {
          case_number: Number(_keyword),
        },
        ['-created'],
        _paging,
      );

      setFetchResp(resp);
    } catch (ex) {
      console.warn(ex);
    }
    AppActions.setLoading(false);
  }

  return (
    <ModalWrapper>
      <h1>倫理風紀</h1>
      <section className="query">
        <label>關鍵字</label>
        <input
          placeholder="案號"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
      </section>

      <section className="actions">
        <Button
          onClick={async () => {
            fetchData(keyword, paging);
          }}>
          搜尋
        </Button>
      </section>

      <Table
        columns={Columns({onChange, hideModal})}
        dataSource={fetchResp?.results || []}
        rowKey={'id'}
        pagination={{
          size: 'small',
          total: fetchResp?.total || 0,
          showSizeChanger: false,
          showTotal: (total) => `共 ${total} 筆, 每頁 ${pageSize} 筆`,
          current: paging.offset / pageSize + 1,
          pageSize: pageSize,
          position: ['topLeft'],
          onChange: (page, pageSize) => {
            if (pageSize) {
              const nextPaging = {
                offset: (page - 1) * pageSize,
                limit: pageSize,
              };
              setPaging(nextPaging);
              fetchData(keyword, nextPaging);
            }
          },
        }}
      />
    </ModalWrapper>
  );
}

const ModalWrapper = styled(ModalCustomStyle)`
  padding: 20px;

  h1 {
    font-size: 24px;
  }

  section.query {
    border: 1px dashed #ccc;
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    margin-bottom: 10px;

    & > label {
      margin-right: 10px;
    }
  }

  section.actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
`;
